import React from "react";
import "./Div1.css";

export const Div1 = () => {
  return (
    <div className="activity-div1">
      <div className="activity-div1-img-container">
        <img src="" alt="" />
      </div>
      <div className="activity-div1-text">
        <span className="activity-div1-overview">OVERVIEW</span>
        <p>
          Socio-cultural itinerary has been one of Prof. Samanta’s multifrontal
          sojourn for holistic social reform and transformation.The multifaceted
          Prof. Achyuta Samanta has not remained contented with KIIT & KISS and
          has never forgotten his roots and philosophy of his life to respect
          mother, motherland and mother tongue. He has always believed in giving
          back to the society and consider Art of Giving as the ethos of his
          life.
        </p>

        <span className="activity-div1-span">
        “Be obliged, not ungrateful.”
        </span>
      </div>
    </div>
  );
};
